"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultVideoStreamIdSet_1 = require("../videostreamidset/DefaultVideoStreamIdSet");
/**
 * [[AllHighestVideoBandwidthPolicy]] implements is a rudimentary policy that simply
 * always subscribes to the highest quality video stream available
 * for all non-self participants.
 */


var AllHighestVideoBandwidthPolicy = /*#__PURE__*/function () {
  function AllHighestVideoBandwidthPolicy(selfAttendeeId) {
    _classCallCheck(this, AllHighestVideoBandwidthPolicy);

    this.selfAttendeeId = selfAttendeeId;
    this.reset();
  }

  _createClass(AllHighestVideoBandwidthPolicy, [{
    key: "reset",
    value: function reset() {
      this.optimalReceiveSet = new DefaultVideoStreamIdSet_1.default();
      this.subscribedReceiveSet = new DefaultVideoStreamIdSet_1.default();
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      this.optimalReceiveSet = this.calculateOptimalReceiveSet(videoIndex);
    }
  }, {
    key: "updateMetrics",
    value: function updateMetrics(_clientMetricReport) {}
  }, {
    key: "wantsResubscribe",
    value: function wantsResubscribe() {
      return !this.subscribedReceiveSet.equal(this.optimalReceiveSet);
    }
  }, {
    key: "chooseSubscriptions",
    value: function chooseSubscriptions() {
      this.subscribedReceiveSet = this.optimalReceiveSet.clone();
      return this.subscribedReceiveSet.clone();
    }
  }, {
    key: "calculateOptimalReceiveSet",
    value: function calculateOptimalReceiveSet(videoIndex) {
      return videoIndex.highestQualityStreamFromEachGroupExcludingSelf(this.selfAttendeeId);
    }
  }]);

  return AllHighestVideoBandwidthPolicy;
}();

exports.default = AllHighestVideoBandwidthPolicy;